import request from '@/utils/request'

export function myGet(url) {
    return request({url: url, method: 'get'})
}

export function myPost(url, data) {
    return request({url: url, method: 'post', data})
}

export function yiDu(id) {
    return request({
        url: '/mobile/config.KanBan/yiDuMsg?id=' + id,
        method: 'get'
    })
}

export function upLoadImg(url, data, file) {
    var formData = new FormData();
    for (var key in data) {
        formData.append(key, data[key]);
    }
    formData.append('file', file);
    return request({url: url, method: 'post', data: formData,});
}

export function checkElementInArray(A, B) {
    for (let i = 0; i < B.length; i++) {
        let elementB = B[i];
        for (let j = 0; j < A.length; j++) {
            let elementA = A[j];
            if (elementA === elementB) {
                return true;
            }
        }
    }
    return false;
}

export function wxConfig(data) {
    return request({
        url: '/wx_hao/Func/getJsApiConfig',
        method: 'post',
        data
    })
}